import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import './ModalFooter.scss';
import Button from '../Button';
import { BUTTON_VARIANTS } from '../Button/Button';

const ModalFooter = (props) => {
  const {
    hasSecondaryCTA,
    primaryCTAText,
    primaryCTAVariant,
    primaryCTAAdditionalProps,
    secondaryCTAText,
    secondaryCTAVariant,
    secondaryCTAAdditionalProps,
    showDivider,
  } = props;

  return (
    <div className={cx('ModalFooter', {
      showDivider,
    })}
    >
      <div className="ModalFooter__inner-container">
        <Button
          className="ModalFooter__PrimaryCTA"
          fullWidth
          variant={primaryCTAVariant}
          {...(primaryCTAAdditionalProps)}
        >
          {primaryCTAText}
        </Button>

        {hasSecondaryCTA
          && (
          <Button
            className="ModalFooter__SecondaryCTA"
            fullWidth
            variant={secondaryCTAVariant}
            {...(secondaryCTAAdditionalProps)}
          >
            {secondaryCTAText}
          </Button>
          )}
      </div>
    </div>
  );
};

ModalFooter.defaultProps = {
  primaryCTAAdditionalProps: {},
  secondaryCTAAdditionalProps: {},
  secondaryCTAText: undefined,
  secondaryCTAVariant: undefined,
  showDivider: true,
};

ModalFooter.propTypes = {
  hasSecondaryCTA: PropTypes.bool.isRequired,
  primaryCTAText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  primaryCTAVariant: BUTTON_VARIANTS.isRequired,
  primaryCTAAdditionalProps: PropTypes.shape({}),
  secondaryCTAText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  secondaryCTAVariant: BUTTON_VARIANTS,
  secondaryCTAAdditionalProps: PropTypes.shape({}),
  showDivider: PropTypes.bool,
};

ModalFooter.displayName = 'ModalFooter';
export default ModalFooter;
